import React, { PureComponent } from "react";

class Designerclassic extends PureComponent {
    render() {
        return (
            <svg width="25" height="6" viewBox="0 0 25 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_165_1787)">
                    <path d="M22.48 1.19922H2.5C1.67157 1.19922 1 2.0051 1 2.99922C1 3.99333 1.67157 4.79922 2.5 4.79922H22.48C23.3084 4.79922 23.98 3.99333 23.98 2.99922C23.98 2.0051 23.3084 1.19922 22.48 1.19922Z" stroke="#181818" strokeWidth="0.9" strokeMiterlimit="10" />
                    <g clipPath="url(#clip1_165_1787)">
                        <path d="M4.80668 1.51696L4.81076 1.51941L4.48634 1.97232L4.80668 1.51696Z" stroke="#181818" />
                        <path d="M7.71683 1.51696L7.72092 1.51941L7.3965 1.97232L7.71683 1.51696Z" stroke="#181818" />
                        <path d="M10.627 1.51696L10.6311 1.51941L10.3067 1.97232L10.627 1.51696Z" stroke="#181818" />
                        <path d="M13.5372 1.51696L13.5413 1.51941L13.2169 1.97232L13.5372 1.51696Z" stroke="#181818" />
                        <path d="M16.4474 1.51696L16.4514 1.51941L16.127 1.97232L16.4474 1.51696Z" stroke="#181818" />
                        <path d="M19.3576 1.51696L19.3617 1.51941L19.0372 1.97232L19.3576 1.51696Z" stroke="#181818" />
                        <path d="M22.2677 1.51696L22.2718 1.51941L21.9474 1.97232L22.2677 1.51696Z" stroke="#181818" />
                    </g>
                </g>
                <defs>
                    <clipPath id="clip0_165_1787">
                        <rect width="25" height="6" fill="white" />
                    </clipPath>
                    <clipPath id="clip1_165_1787">
                        <rect width="21" height="4" fill="white" transform="translate(2 1)" />
                    </clipPath>
                </defs>
            </svg>
        );
    }
}

export default Designerclassic;